import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Laura M.',
  role: 'Mamá de Leo (3 años)',
  text: '¡Me salvó la vida! Antes no sabía qué hacer en las tardes con mi hijo. Ahora tenemos rutinas súper divertidas y he notado cómo habla mucho mejor.',
  emoji: '👩'
}, {
  name: 'Carmen R.',
  role: 'Abuela de Sofía (5 años)',
  text: 'Los juegos con materiales caseros son una maravilla. Sofía se divierte muchísimo cuando viene a visitarme y yo siento que aporto a su aprendizaje.',
  emoji: '👵'
}, {
  name: 'Ana P.',
  role: 'Mamá de gemelos (4 años)',
  text: 'Pensé que no tendría tiempo, pero la guía es tan práctica que aplicamos los consejos mientras cocinamos o nos bañamos. ¡100% recomendada!',
  emoji: '👱‍♀️'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-pastel-mint/20" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <div className="text-center mb-16" data-id="element-105">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-106">
            Familias Felices ❤️
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-107">
            Lo que dicen otras mamás y abuelas sobre la guía
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-108">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm relative" data-id="element-109">
              <div className="absolute -top-6 left-8 text-5xl bg-white rounded-full p-1 shadow-sm" data-id="element-110">
                {testimonial.emoji}
              </div>
              <div className="flex gap-1 text-pastel-yellow text-2xl mb-4 mt-4" data-id="element-111">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-gray-700 text-lg mb-6 italic" data-id="element-112">
                "{testimonial.text}"
              </p>
              <div data-id="element-113">
                <p className="font-bold text-brand-dark text-lg" data-id="element-114">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-500" data-id="element-115">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}